export const getFullTotal = () => {
    let extraValue = 0;

    app.$store.state.simplePlan.extraSteps.forEach((step) => {
        if (step.isPercentage && step.amount > 0) {
            extraValue = Math.round((app.$store.state.simplePlan.upperJawTotal + app.$store.state.simplePlan.lowerJawTotal) * (step.amount / 100));
        }
    });
    return extraValue + app.$store.state.simplePlan.upperJawTotal + app.$store.state.simplePlan.lowerJawTotal + app.$store.state.simplePlan.extraTotal;
}

export const calculateDiscount = () => {
    const discountAmount = parseInt(app.$store.state.simplePlan.discountAmount);
    if (isNaN(discountAmount)) return 0;

    if (app.$store.state.simplePlan.discountMode === 'percentage') {
        return Math.round(getFullTotal() * (discountAmount/100));
    }
    return discountAmount;
}
